import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  footerSpacer: {
    paddingBottom: 280,
    [theme.breakpoints.down(600)]: {
      paddingBottom: 554,
    },
  },
});

const FooterSpacer = (props) => {
  const { classes } = props;
  return (
    <div className={classes.footerSpacer} />
  );
};

FooterSpacer.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(FooterSpacer);
